import React from "react";
import { Slider as DebtSlider } from "@mui/material";

const marksMobile = [
  {
    value: 10000,
    label: "$10,000",
  },
  {
    value: 300000,
    label: "$300,000+",
  },
];

const Step1 = ({
  handleSliderChange,
  setFormError,
  formError,
  debtValue,
  values,
  setStep,
  step,
}) => {
  const formatNumber = (text) => {
    return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const points = [
    "Exclusive Program for Texas Residents",
    "Specialists for resolving $50K to $300K+",
    "Free No-Obligation Consultation",
    "Receive up to 40% Lower Fees*",
  ];

  return (
    <>
      <div className="text-black flex flex-col gap-2 font-medium text-xl sm:text-2xl mt-8 mb-6 w-auto sm:w-[520px] mx-auto text-start">
        {points.map((point, index) => (
          <p className="flex items-center" key={index}>
            <img src="/svgs/check-orange.svg" className="me-2" alt="Check" />{" "}
            {point}
          </p>
        ))}
      </div>
      <div className="w-auto">
        <div className="mt-8 mb-12">
          <h2 className="text-center text-green-700 text-6xl font-bold mb-6">
            ${formatNumber(debtValue)}
          </h2>
          <div className="px-8 text-center">
            <DebtSlider
              defaultValue={63000}
              min={10000}
              max={300000}
              marks={marksMobile}
              step={1000}
              onChange={handleSliderChange}
              sx={{
                fontSize: "1.0rem",
                color: "green",
                "& .MuiSlider-thumb": {
                  color: "green",
                  height: 24,
                  width: 24,
                },
                "& .MuiSlider-track": {
                  backgroundColor: "green",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "green",
                },
                "& .MuiSlider-markLabel": {
                  fontSize: "1.2rem",
                },
              }}
            />
          </div>
        </div>
        {formError.debtValue ? (
          <p className="w-full flex justify-center items-center my-4 text-lg font-semibold text-red-700">
            {formError.debtValue}
          </p>
        ) : null}
        <h5 className="text-sky-700 text-xl sm:text-2xl mt-3 mb-5">
          Select Your Debt Amount
        </h5>
        <button
          className="transition bg-green-700 hover:bg-green-800 px-16 text-white font-bold py-2 rounded border-radius-5"
          onClick={() => {
            if (values.debtValue) {
              if (step < 3) setStep(step + 1);
            } else {
              setFormError({
                ...formError,
                debtValue: "Please select a debt amount.",
              });
            }
          }}
        >
          Let's Go
        </button>
      </div>
    </>
  );
};

export default Step1;
